import { useEffect, useState } from 'react'

import { Button } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import { Delete } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import ContentWithOutSubTabs from 'Components/UI/Molecules/ContentWithOutSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { SUCURSAL_ORIGEN } from 'Constants'
import { interfaces } from 'service/interfaces'

import {
  FieldsEdit,
  FieldsEditManual,
  FieldsEditMultiple,
  FieldsEditResto,
} from './SearchProduct/fields'
import ListStock from './SearchProduct/ListStock'
import { ProductFields } from './Fields'
import SearchProduct from './SearchProduct'

const Product = (props) => {
  const {
    data,
    handleChange,
    openCancel,
    edit,
    dataBefore,
    handleclose,
    cancel,
    setRender,
    render,
    setData,
    permissions,
  } = props

  const [tab, setTab] = useState(0)
  const [rows, setRows] = useState(data.productList)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [dataSaldos, setDataSaldos] = useState(data.infoMain.saldos)
  const origenEncontrado = SUCURSAL_ORIGEN.find(
    (sucursal) => sucursal.label === data.infoMain.origen
  )
  const empresaId = origenEncontrado ? origenEncontrado.id : null

  async function orderInfo(id) {
    await interfaces.salesOrders.infoOneOrders(id).then((res) => {
      setData((prevData) => ({
        ...prevData,
      }))
      setDataSaldos(res.data.infoMain.saldos)
      setRows(res.data.productList)
    })
  }

  useEffect(() => {
    const id = data.infoMain.id
    orderInfo(id)
    // eslint-disable-next-line
  }, [rows.length, data.infoMain.id])

  const {
    state: paymentDetail,
    setOpen: setOpenPaymentDetail,
    setClose: setClosePaymentDetail,
  } = SetState()

  const handleChangeItem = (name, value) => {
    setSelectedRow((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  const createDismissableSnackbar = useCustomSnackbar()

  const editItem = async () => {
    setIsLoading(true)
    const values = {
      id: selectedRow.id,
      empresa: empresaId,
      precio: Number(selectedRow.precioUnitario),
      cantidad: Number(selectedRow.cantidad),
      detalle: selectedRow.observacion,
      orden: Number(selectedRow.orden),
      nrodev: selectedRow.nrodev ? Number(selectedRow.nrodev) : null,
      porcentaje: selectedRow.porcentaje,
      medio_pago: selectedRow.medio_pago,
      submedio_pago: selectedRow.submedio_pago,
    }

    await interfaces.salesOrders.editProductItem(values).then((res) => {
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
      const updatedRows = rows.map((row) =>
        row.id === selectedRow.id
          ? {
              ...row,
              porcentaje: values.porcentaje,
              subtotal: values.precio,
              total: values.precio,
              observacion: values.detalle,
              cantidad: values.cantidad,
              nrodev: values.nrodev,
            }
          : row
      )
      setRows(updatedRows)
      setData((prevData) => ({ ...prevData, productList: updatedRows }))
      setRender(!render)
      orderInfo(data.infoMain.id)
      handleclose()
    })
    setClosePaymentDetail()
    setIsLoading(false)
  }

  async function deleteDetail(id) {
    const body = {
      id: id,
      empresa: empresaId,
    }
    setIsLoading(true)
    await interfaces.salesOrders.deleteProduct(body).then((res) => {
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
      deleteItem(id)
    })
    setRender(!render)
    handleclose()
    setIsLoading(false)
  }

  const deleteItem = (id) => {
    const newItem = rows.filter((e) => !id.includes(e.id))

    setRows(newItem)
    setData((prevData) => ({
      ...prevData,
      productList: newItem,
    }))
    handleChange(newItem)
    setRender(!render)
  }

  const iconDelete = (id, nrodev, codigo) => (
    <IconButton
      onClick={(event) => {
        event.stopPropagation()

        const idsToDelete = codigo
          ? rows.filter((item) => item.nrodev === nrodev).map((item) => item.id)
          : [id]

        deleteDetail(idsToDelete)
      }}
      disabled={data.comprobantes.length > 0 || permissions.allowEditMin ? true : !edit}
      style={{ padding: '0px' }}
    >
      <Delete />
    </IconButton>
  )

  const onClickRow = (index) => {
    if (!edit) return
    const item = {
      ...index,
      precioUnitario: parseFloat(
        (parseFloat(index.subiva.replace(/[^0-9.]/g, '')) / index.cantidad).toFixed(2)
      ),
    }
    setSelectedRow(item)
    setOpenPaymentDetail(true)
  }

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            <div
              style={{
                paddingTop: '1rem',
                cursor: edit ? 'pointer' : '',
                marginTop: '6rem',
              }}
            >
              <BasicTable
                col={[
                  { title: 'Orden comp.', style: { width: '20px' } },
                  { title: 'Código', style: { width: '40px' } },
                  { title: 'Descripción', style: { width: '150px' } },
                  { title: 'Nº V', style: { width: '40px' } },
                  { title: 'Oblea', style: { width: '40px' } },
                  { title: 'Cant.', style: { width: '10px' } },
                  {
                    title: data.infoMain.origen !== 'DOS' ? 'P. unitario s/IVA' : 'Precio unitario',
                    style: { width: '80px' },
                  },
                  { title: 'Subtotal s/IVA', style: { width: '80px' } },
                  {
                    title: data.infoMain.origen !== 'DOS' ? 'Subtotal c/IVA' : 'Subtotal',
                    style: { width: '70px' },
                  },
                  { title: '', style: { width: '10px' } },
                  { title: '', style: { display: 'none' } },
                  { title: '', style: { display: 'none' } },
                  { title: '', style: { display: 'none' } },
                  { title: '', style: { display: 'none' } },
                  { title: '', style: { display: 'none' } },
                  { title: '', style: { display: 'none' } },
                  { title: '', style: { display: 'none' } },
                ]}
                size="small"
                rows={rows.map((row) => {
                  // const alicuota = parseFloat(data.infoMain.alicuota) / 100
                  // const precioNeto = Math.ceil((row.unitario / (1 + alicuota)) * 1000) / 1000
                  // const subtotal = Math.ceil(precioNeto * row.cantidad * 1000) / 1000
                  // const subtotalIVA =
                  //   Math.ceil(row.unitario * (1 + alicuota) * row.cantidad * 1000) / 1000
                  return {
                    orden: row.orden,
                    codigo: row.codigo,
                    descripcion: row.descripcion,
                    nrodev: row.nrodev,
                    oblea: row.oblea,
                    cantidad: row.cantidad,
                    precio: `$${row.unitario.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`,
                    subtotal: `$${row.total.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`,
                    subiva: `$${(
                      row.total *
                      (1 + parseFloat(data.infoMain.alicuota) / 100)
                    ).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`,
                    action:
                      !row.codigo && row.oblea && [3, 8, 13, 52].includes(data.infoMain.comprobante)
                        ? ''
                        : iconDelete(row.id, row.nrodev, row.codigo),
                    observacion: row.observacion,
                    id: row.id,
                    transporte: Number(row.transporte),
                    producto: row.producto,
                    medio_pago: row.medio_pago,
                    submedio_pago: row.submedio_pago,
                    porcentaje: row.porcentaje,
                  }
                })}
                onClickRow={permissions.allowEditMin ? () => {} : onClickRow}
              />
            </div>

            {![3, 8, 13, 52].includes(data.infoMain.comprobante) && (
              <div
                style={{
                  marginTop: '0.5rem',
                  position: 'absolute',
                  bottom: '7rem',
                  width: '97%',
                  zIndex: 10,
                  backgroundColor: 'white',
                  paddingTop: '.5rem',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Button
                  color="secondary"
                  variant="contained"
                  size="small"
                  style={{
                    marginLeft: '1.5rem',
                    backgroundColor: '3E984C',
                  }}
                  onClick={openCancel}
                  disabled={data.comprobantes.length > 0 || permissions.allowEditMin ? true : !edit}
                >
                  {' '}
                  <AddIcon />
                </Button>
              </div>
            )}
            <div
              style={{
                marginTop: '0.5rem',
                position: 'absolute',
                bottom: '4rem',
                width: '97%',
                zIndex: 10,
                backgroundColor: 'white',
                paddingTop: '.5rem',
              }}
            >
              <InputsWithoutValidate
                fields={ProductFields(dataSaldos, data.ctaCliente)}
                spacing={2}
              />
            </div>
          </>
        )
      default:
        break
    }
  }

  const isSubmitDisabled =
    selectedRow?.descripcion === 'BONIFICACION'
      ? Number(selectedRow?.subiva) > data.infoMain.saldos.total
      : !selectedRow?.subiva

  return (
    <>
      <ContentWithOutSubTabs value={tab} setValue={setTab} children={renderTabs(tab)} />
      {/* ADD */}
      {cancel.suspense && (
        <SearchProduct
          data={dataBefore.data}
          open={openCancel}
          handleClose={handleclose}
          render={render}
          setRender={setRender}
          dataInfo={data}
          rows={rows}
          setRows={setRows}
          setData={setData}
          permissions={permissions}
        />
      )}
      {/* modal edit */}
      <DialogComponent
        open={paymentDetail.open}
        title={selectedRow?.descripcion.toUpperCase()}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge="500px"
        children={
          selectedRow?.codigo ? (
            <InputsWithoutValidate
              fields={FieldsEdit(selectedRow, handleChangeItem, data.infoMain.alicuota)}
              spacing={2}
            />
          ) : ['RESTO VENTA'].includes(selectedRow?.descripcion) ? (
            <InputsWithoutValidate
              fields={FieldsEditResto(selectedRow, handleChangeItem)}
              spacing={2}
            />
          ) : ['RECARGO', 'BONIFICACION', 'ENVIO'].includes(selectedRow?.descripcion) ? (
            <InputsWithoutValidate
              fields={FieldsEditMultiple(selectedRow, handleChangeItem, dataBefore)}
              spacing={2}
            />
          ) : selectedRow ? (
            <InputsWithoutValidate
              fields={FieldsEditManual(selectedRow, handleChangeItem, data.infoMain.alicuota)}
              spacing={2}
            />
          ) : null
        }
        actions={
          <CancelConfirmButtons
            disabledSubmit={isLoading || isSubmitDisabled || !selectedRow.subiva}
            disabledCancel={isLoading}
            isLoading={isLoading}
            onClickSubmit={editItem}
            onClickCancel={setClosePaymentDetail}
          />
        }
      />
      {/* cuando es nota de credito, muestra este componente */}
      {[3, 8, 13, 52].includes(data.infoMain.comprobante) && (
        <ListStock
          setFormEdit={setRows}
          data={data}
          setIsLoading={setIsLoading}
          empresaId={empresaId}
          setData={setData}
          setRender={setRender}
          edit={edit}
        />
      )}
    </>
  )
}
export default Product
